<template>
    <div class="NameList-wrap">
        <div class="name-list">
            <div class="list-title">
                最新报名客户
            </div>
            <div v-if="list.length>0" class="list-content">
                <div class="swiper-container">
                    <swiper class="swiper-wrapper" :options="swiperOption" ref="nameSwiper">
                        <swiper-slide class="swiper-slide" v-for="(item,index) in list" :key="index" :realIndex="index" >
                            <div class="item-wrap">
                                <span class="name">{{item.uname}}</span>
                                <span class="phone">{{item.mobile}}</span>
                                <span class="time">{{item.time}}</span>
                            </div>
                        </swiper-slide>
                    </swiper>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"NameList",
    props: {
        list: Array,
    },
    data(){
        return{
            value: '',
            swiperOption: {
                
                

                autoplay: {
                        delay: 3000,
                        
                        
                    },
                    loop: true,
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    autoHeight: true,
                    autoplay: 3000,
                    speed: 400,
                    disableOnInteraction: false,
                    autoplayDisableOnInteraction: false,
                    mousewheelControl: true,
                    observeParents: true,
                
            }
        }
    }

}
</script>

<style lang="less">
    .NameList-wrap{
        .name-list{
            margin-top: 40px;
            margin-bottom: 120px;
            .list-title{
                text-align: center;
                font-size: 48px;
                font-weight: 600;
            }
            .list-content{
                width: 100%;
                background: url(../../static/image/bjt.png) no-repeat;
                background-position: center;
                background-size: 100% 100%;
                height: 510px;
                padding:30px 50px;
                overflow: hidden;
                .swiper-container{
                    height: 410px;
                    overflow: hidden;
                    .swiper-wrapper{
                        .swiper-slide{
                            height: 80px;
                                .item-wrap{
                                    height: 100%;
                                    display: flex;
                                    justify-content: space-between;
                                    line-height: 80px;
                                    font-size: 36px;
                                }   
                        }
                    }
                }
            }
        }
    }
</style>